import Wahanda from 'common/wahanda';

import { Errors } from './types';
import { BE_TURNSTILE_TOKEN_NAME } from './constants';

export const captchaValidations = (errors: Errors) => ({
  [BE_TURNSTILE_TOKEN_NAME]: {
    name: BE_TURNSTILE_TOKEN_NAME,
    type: 'hidden',
    dataTest: 'login-form-captcha-input',
    hasError: !!errors[BE_TURNSTILE_TOKEN_NAME],
    errorMessage: errors[BE_TURNSTILE_TOKEN_NAME]?.message,
    fullBorder: true,
    label: undefined,
    rules: {
      required: Wahanda.lang.validate.defaults.required,
    },
  },
});
